/**
 * In-memory Request Monitor for Admin Console.
 * Tracks last 50 requests, counters (API vs Static vs Blocked), top features, and rows_read.
 */

const MAX_LOG_SIZE = 50;

const monitorState = {
  counters: {
    api: 0,
    static: 0,
    blocked: 0
  },
  byFeature: {},
  totalRowsRead: 0,
  recentRequests: []
};

const listeners = new Set();

function emitUpdate() {
  listeners.forEach((fn) => fn(monitorState));
}

export function recordRequest({ method, path, status, ms, rowsRead = 0, featureId = 'other', blocked = false, error = null }) {
  if (blocked) {
    monitorState.counters.blocked++;
  } else {
    monitorState.counters.api++;
  }

  if (rowsRead > 0) {
    monitorState.totalRowsRead += rowsRead;
  }

  // Update feature count
  monitorState.byFeature[featureId] = (monitorState.byFeature[featureId] || 0) + 1;

  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).substr(2, 4)}`,
    time: new Date().toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }),
    method: method || 'GET',
    path: path || '/',
    status: blocked ? 'BLOCKED' : status || 200,
    ms: Math.round(ms || 0),
    rowsRead: rowsRead || 0,
    featureId,
    error: error || null
  };

  monitorState.recentRequests = [entry, ...monitorState.recentRequests].slice(0, MAX_LOG_SIZE);
  emitUpdate();
}

export function recordStaticRequest(featureId = 'static') {
  monitorState.counters.static++;
  monitorState.byFeature[featureId] = (monitorState.byFeature[featureId] || 0) + 1;
  emitUpdate();
}

export function getMonitorState() {
  return monitorState;
}

export function clearRequestLog() {
  monitorState.recentRequests = [];
  monitorState.counters = { api: 0, static: 0, blocked: 0 };
  monitorState.byFeature = {};
  monitorState.totalRowsRead = 0;
  emitUpdate();
}

export function subscribeRequestMonitor(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
